// core
import React from "react";
import { useFormikContext } from "formik";

// hooks
import useSettingsValidation from "../../hooks/useSettingsValidation";
import {
    calculateMaxIncomeMonthlyCover,
    maxMonthlyIncomeCoverPercentage
} from "../../../common/shared/productHelpers";

// components
import { IStreamlineSettingsClientProps } from "./StreamlineBaseClientSettings";
import ClientSettingsBoxOccupation from "../Clients/ClientSettingsBoxOccupation/ClientSettingsBoxOccupation";
import MonthlyCoverSlider from "../../../common/components/Forms/MonthlyCoverSlider/MonthlyCoverSlider";

// interfaces
import { IQuoteSettings } from "../../interfaces/form/IQuoteSettings";
import ProductType from "../../../common/interfaces/enums/ProductType";

const StreamlineIncomeSettings: React.FC<IStreamlineSettingsClientProps> = (props) => {
    const { client, name } = props;
    const {
        handleChange,
        setFieldValue,
        setFieldTouched,
        validateField
    } = useFormikContext<IQuoteSettings>();
    const { getFormikError } = useSettingsValidation();

    return (
        <React.Fragment>
            <ClientSettingsBoxOccupation
                client={client}
                name={`${name}`}
                setClient={handleChange}
            />
            <MonthlyCoverSlider
                id={`${name}.${ProductType.Income}.monthlyCover`}
                name={`${name}.${ProductType.Income}.monthlyCover`}
                label={"Monthly Income Cover"}
                maxValue={calculateMaxIncomeMonthlyCover(client.occupation?.income)}
                value={client[ProductType.Income]?.monthlyCover}
                onChange={(monthlyCover) => {
                    setFieldValue(
                        `${name}.${ProductType.Income}.monthlyCover`,
                        monthlyCover
                    );
                }}
                onBlur={() => {
                    setFieldTouched(`${name}.${ProductType.Income}.monthlyCover`);
                    validateField(`${name}.${ProductType.Income}.monthlyCover`);
                }}
                isDisabled={!client.income || !client.occupation?.income}
                percentageRangeMax={maxMonthlyIncomeCoverPercentage}
                hasInput
                isCurrency
                isRoundUp
                tooltipContent="You can insure up to 75% of your gross (before tax) income. Most people insure 75% but you can protect less if you want to."
                hasError={
                    getFormikError(`${name}.${ProductType.Income}.monthlyCover`) ||
                    getFormikError(`${name}.${ProductType.Income}`)
                }
            />
        </React.Fragment>
    );
};

export default StreamlineIncomeSettings;
